import {Sparkles} from 'lucide-react'

function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0a0908] px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 text-center sm:flex-row sm:text-left">
        <div className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-amber-400" aria-hidden="true" />
          <span className="font-serif text-base font-semibold text-white">
            Tattoo<span className="text-amber-400">Cost</span>Calculator
          </span>
        </div>
        <p className="max-w-md text-xs leading-relaxed text-slate-500">
          Estimates are for informational purposes only and based on industry pricing averages. Actual tattoo and
          laser removal costs vary by artist, clinic, and location. Always consult a licensed professional.
        </p>
        <p className="text-xs text-slate-600">
          &copy;
          {' '}
          {new Date().getFullYear()}
          {' '}
          TattooCostCalculator.com
        </p>
      </div>
    </footer>
  )
}

export default Footer
